import { graphql } from 'gatsby'

// eslint-disable-next-line no-restricted-exports
export { default } from './Tag'

export const query = graphql`
  query ($slug: String!, $limit: Int!, $skip: Int!) {
    ghostTag(slug: { eq: $slug }) {
      ...GhostTagFields
    }
    allGhostPost(
      sort: { published_at: DESC }
      filter: { tags: { elemMatch: { slug: { eq: $slug } } } }
      limit: $limit
      skip: $skip
    ) {
      nodes {
        ...GhostPostFields
      }
    }
    allGhostPostRecent: allGhostPost(sort: { published_at: DESC }, limit: 5) {
      nodes {
        ...GhostPostFields
      }
    }
  }
`
